'use strict';

var Model = require('base/Colido.Model');

/**
 * Model for a system language
 *
 * @category   Model
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var SystemLanguageModel = Model.extend({
    idAttribute: 'code',
});

module.exports = SystemLanguageModel;